import { Navigate, lazyRouteComponent } from 'src/lib/routing';

import { AIQueryAnalyticsContextProvider } from 'containers/AIQuery/AIQueryAnalytics';
import { ChatFollowupsContextProvider } from 'containers/AIQuery/containers/AIQueryChatContainer/components/ChatFollowups/ChatFollowupsContext';
import { RequireAuth } from 'containers/Auth/RequireAuth';

import type { RouteObject } from 'src/lib/routing';

const AIQueryContainer = lazyRouteComponent(() => import('containers/AIQuery/AIQueryContainer'), 'AIQueryContainer');
const AIQueryChatContainer = lazyRouteComponent(
  () => import('containers/AIQuery/containers/AIQueryChatContainer/AIQueryChatContainer'),
  'AIQueryChatContainer',
);
const BuildStudy = lazyRouteComponent(() => import('./BuildStudy/BuildStudy'), 'BuildStudy');
const Recruit = lazyRouteComponent(() => import('./Recruit/Recruit'), 'Recruit');
const RecruitMessagesContent = lazyRouteComponent(
  () => import('./Recruit/containers/MessagesContent'),
  'MessagesContent',
);
const RecruitParticipantsContent = lazyRouteComponent(
  () => import('./Recruit/containers/ParticipantsContent'),
  'ParticipantsContent',
);
const RecruitSettingsContent = lazyRouteComponent(
  () => import('./Recruit/containers/SettingsContent'),
  'SettingsContent',
);
const Results = lazyRouteComponent(() => import('./Results/Results'), 'Results');
const ResultsTaskContentRouter = lazyRouteComponent(
  () => import('./Results/Unmoderated/containers/TaskContentRouter'),
  'TaskContentRouter',
);
const ResultsFindingsContent = lazyRouteComponent(
  () => import('./Results/containers/FindingsContent'),
  'FindingsContent',
);
const ResultsParticipantContent = lazyRouteComponent(
  () => import('./Results/containers/ParticipantContent'),
  'ParticipantContent',
);
const ResultsTranscriptPage = lazyRouteComponent(
  () => import('containers/Transcript/TranscriptPage'),
  'ResultsTranscriptPageGate',
);
const Schedule = lazyRouteComponent(() => import('./Schedule/Schedule'), 'Schedule');
const StudiesContainer = lazyRouteComponent(() => import('./StudiesContainer'), 'StudiesContainer');
const StudyAIQueryLandingContainer = lazyRouteComponent(
  () => import('./containers/StudyAIQueryLandingContainer'),
  'StudyAIQueryLandingContainer',
);
const StudyPageNotFound = lazyRouteComponent(() => import('./components/StudyPageNotFound'), 'StudyPageNotFound');

export const studiesRoutes: RouteObject[] = [
  {
    path: 'studies/:studyId',
    element: (
      <RequireAuth>
        <StudiesContainer />
      </RequireAuth>
    ),
    children: [
      {
        index: true,
        element: <Navigate to="build" replace />,
      },
      {
        path: 'build',
        element: <BuildStudy />,
      },
      {
        path: 'recruit',
        element: <Recruit />,
        children: [
          {
            index: true,
            element: <Navigate to="participants" replace />,
          },
          {
            path: 'participants/:segmentId?',
            element: <RecruitParticipantsContent />,
          },
          {
            path: 'messages',
            element: <RecruitMessagesContent />,
          },
          {
            path: 'settings',
            element: <RecruitSettingsContent />,
          },
        ],
      },
      {
        path: 'schedule',
        element: <Schedule />,
      },
      {
        path: 'results',
        element: <Results />,
        children: [
          {
            index: true,
            element: <ResultsTaskContentRouter />,
          },
          {
            path: 'task/:taskId?',
            element: <ResultsTaskContentRouter />,
          },
          {
            path: 'participant/:participantId?',
            element: <ResultsParticipantContent />,
          },
          {
            path: 'finding/:findingId?',
            element: <ResultsFindingsContent />,
          },
          {
            path: 'transcript/:videoCode',
            element: <ResultsTranscriptPage />,
          },
        ],
      },
      {
        path: 'ask-ai',
        element: (
          <AIQueryAnalyticsContextProvider>
            <AIQueryContainer />
          </AIQueryAnalyticsContextProvider>
        ),
        children: [
          {
            index: true,
            element: <StudyAIQueryLandingContainer />,
          },
          {
            path: ':chatId',
            element: (
              <div className="h-full [&>div]:!h-full">
                <ChatFollowupsContextProvider>
                  <AIQueryChatContainer />
                </ChatFollowupsContextProvider>
              </div>
            ),
          },
        ],
      },
      {
        path: '*',
        element: <StudyPageNotFound />,
      },
    ],
  },
];
